import { createContext, useContext, useState } from 'react'

export interface DemoViewerSettings {
  sidebarWidth: number
  sidebarAutoCollapse: boolean
}

export const DEFAULT_SIDEBAR_WIDTH = 232
export const DEFAULT_DEMO_VIEWER_SETTINGS: DemoViewerSettings = {
  sidebarWidth: DEFAULT_SIDEBAR_WIDTH,
  sidebarAutoCollapse: true,
}

const STORAGE_KEY = 'layer-demo-viewer-settings'

const loadSettings = (): DemoViewerSettings => {
  try {
    const stored = localStorage.getItem(STORAGE_KEY)
    if (!stored) return DEFAULT_DEMO_VIEWER_SETTINGS
    return { ...DEFAULT_DEMO_VIEWER_SETTINGS, ...JSON.parse(stored) }
  } catch {
    return DEFAULT_DEMO_VIEWER_SETTINGS
  }
}

export interface DemoViewerSettingsContextType {
  settings: DemoViewerSettings
  updateSettings: (partial: Partial<DemoViewerSettings>) => void
}

export const DemoViewerSettingsContext = createContext<DemoViewerSettingsContextType>({
  settings: DEFAULT_DEMO_VIEWER_SETTINGS,
  updateSettings: () => {},
})

export const useDemoViewerSettings = () => useContext(DemoViewerSettingsContext)

export const useDemoViewerSettingsProvider = (): DemoViewerSettingsContextType => {
  const [settings, setSettings] = useState<DemoViewerSettings>(loadSettings)

  const updateSettings = (partial: Partial<DemoViewerSettings>) => {
    const next = { ...settings, ...partial }
    setSettings(next)
    localStorage.setItem(STORAGE_KEY, JSON.stringify(next))
  }

  return { settings, updateSettings }
}
